import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import './index.css';
import 'rsuite/dist/rsuite-no-reset.min.css';
import App from './App';
import { logsAPI } from './services/api';

// Polyfill Buffer para el browser: @react-pdf/renderer espera el global
// Buffer de Node al procesar fuentes/imagenes. Sin esto la generacion PDF
// falla con "Buffer is not defined". Se ejecuta antes del render.
window.Buffer = Buffer;

// Handlers globales de errores del navegador — reportan a system_logs para
// que dejen de invisibilizarse. Cubre casos que ErrorBoundary NO puede atrapar
// (eventos async fuera del render tree, promesas sin catch, listeners, etc).
// Se debouncean 1s para no inundar el server ante un loop de errores.
(function attachGlobalErrorHandlers() {
    let ultimoReporte = 0;
    const puedeReportar = () => {
        const now = Date.now();
        if (now - ultimoReporte < 1000) return false;
        ultimoReporte = now;
        return true;
    };

    window.addEventListener('error', (e) => {
        if (!puedeReportar()) return;
        logsAPI.reportFrontend({
            level: 'error',
            category: 'window:error',
            mensaje: e?.error?.message || e?.message || 'window.onerror sin mensaje',
            stack: e?.error?.stack || null,
            contexto: {
                filename: e?.filename || null,
                lineno: e?.lineno || null,
                colno: e?.colno || null
            },
            url: window.location.href
        });
    });

    window.addEventListener('unhandledrejection', (e) => {
        if (!puedeReportar()) return;
        const reason = e?.reason;
        logsAPI.reportFrontend({
            level: 'error',
            category: 'window:unhandledrejection',
            mensaje: reason?.message || String(reason) || 'Promise rejection sin mensaje',
            stack: reason?.stack || null,
            contexto: null,
            url: window.location.href
        });
    });
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
